// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__8rU1t","sk-stretchdelay":"styles_sk-stretchdelay__RR+vc"};